module.exports = __webpack_public_path__ + "img/ff7c928.jpeg";